import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useJsApiLoader,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const BookingRouteMap = ({ src_lat, src_lng, dest_lat, dest_lng }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  });

  const [directions, setDirections] = useState(null);

  useEffect(() => {
    if (!isLoaded || !src_lat || !src_lng || !dest_lat || !dest_lng) return;

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: { lat: parseFloat(src_lat), lng: parseFloat(src_lng) },
        destination: { lat: parseFloat(dest_lat), lng: parseFloat(dest_lng) },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
        } else {
          console.error("Directions request failed:", result);
        }
      }
    );
  }, [isLoaded, src_lat, src_lng, dest_lat, dest_lng]);

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{ lat: parseFloat(src_lat), lng: parseFloat(src_lng) }}
      zoom={13}
    >
      <Marker position={{ lat: parseFloat(src_lat), lng: parseFloat(src_lng) }} label="P" />
      <Marker position={{ lat: parseFloat(dest_lat), lng: parseFloat(dest_lng) }} label="D" />
      {/* {directions && <DirectionsRenderer directions={directions} />} */}
    </GoogleMap>
  );
};

export default BookingRouteMap;
